export default __webpack_public_path__ + "static/media/document-icon.3b8da26b.svg";